import { Box, Stack, Tooltip } from "@mui/material";
import React from "react";
import { IRiskListItem, RiskListItem } from "ui/Scripts/source/models/risk/riskListItem";
import { ListStateIconRisk } from "source/components/framework/List/ListStateIconRisk";
import { RiskType } from "ui/Scripts/source/models/enums";
import { ListStateIconOpportunity } from "source/components/framework/List/ListStateIconOpportunity";

interface IRiskListCategoryColProps {
    item: IRiskListItem
}

export const RiskListCategoryCol = (props: IRiskListCategoryColProps) => {
    return (
        <Stack direction="row" useFlexGap flexWrap="nowrap" overflow="hidden" alignItems="center">
            {(props.item.riskType === RiskType.Risk
                ? <ListStateIconRisk
                    customColor={!props.item.opportunity ? "error" : "warning"}
                    tooltip={RiskListItem.getRiskTypeText(props.item.riskType, props.item.opportunity)}
                />
                : <ListStateIconOpportunity
                    customColor="success"
                    tooltip={RiskListItem.getRiskTypeText(props.item.riskType, props.item.opportunity)}
                />
            )}
            <Box sx={{ marginLeft: 1, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
                <Tooltip title={props.item.riskCategoryCode}>
                    <span>{props.item.riskCategoryCode}</span>
                </Tooltip>
            </Box>
        </Stack>
    );
};
